import useGetFreeTrialCourses from './useGetFreeTrialCourses';

export default useGetFreeTrialCourses;
